<template lang="html">
  <transition name="fade-anim">
    <modal v-if="$store.getters['modals/inventedGames/isOpened']" @close="close">
      <div class="th-modal container">
        <ModalClose
          :iconSmall="true"
          style="left:25px!important;right: unset!important;"
          @click="close" />

        <div class="invented-title">
          <svg width="31" height="42" viewBox="0 0 31 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 26.3572V40.0007L16 35.9076L24 40.0007V25.334" stroke="#FF7384" stroke-width="3" stroke-miterlimit="10" stroke-linejoin="round"/>
            <path d="M15.4529 3.07691C16.1714 3.07691 16.8899 3.33691 17.456 3.85537L18.3391 4.66459L19.5114 4.41998C19.7145 4.37844 19.9175 4.3569 20.1175 4.3569C21.3868 4.3569 22.5483 5.1769 22.9437 6.43228L23.3037 7.57535L24.4421 7.95073C25.8883 8.42765 26.7375 9.92149 26.4083 11.4076L26.1483 12.5769L26.9467 13.4707C27.9606 14.6061 27.9498 16.3245 26.9221 17.4476L26.1129 18.3307L26.3575 19.503C26.6683 20.9938 25.7975 22.4768 24.3452 22.9337L23.2021 23.2937L22.8268 24.4322C22.4191 25.6676 21.2668 26.4691 20.0129 26.4691C19.8006 26.4691 19.5852 26.446 19.3683 26.3983L18.1991 26.1383L17.3052 26.9368C16.7406 27.4414 16.0345 27.6922 15.3299 27.6922C14.6114 27.6922 13.893 27.4322 13.3268 26.9137L12.4437 26.1045L11.2714 26.3491C11.0683 26.3906 10.8653 26.4122 10.6653 26.4122C9.39605 26.4122 8.23451 25.5922 7.83913 24.3368L7.47913 23.1937L6.34068 22.8184C4.89453 22.3414 4.0453 20.8476 4.37453 19.3615L4.63453 18.1922L3.83761 17.2968C2.82377 16.1615 2.83454 14.443 3.86223 13.3199L4.67145 12.4369L4.42838 11.263C4.11761 9.77226 4.98837 8.28919 6.44068 7.83227L7.58375 7.47227L7.95913 6.33382C8.36682 5.09844 9.51912 4.2969 10.773 4.2969C10.9853 4.2969 11.2007 4.31998 11.4176 4.36767L12.5868 4.62767L13.4806 3.82921C14.0422 3.32768 14.7483 3.07691 15.4529 3.07691ZM15.4529 0C14.0914 0 12.7776 0.456921 11.716 1.29538C11.4037 1.24615 11.0868 1.22153 10.773 1.22153C8.28528 1.22153 6.0776 2.73383 5.1653 5.02152C2.52069 6.03074 0.942238 8.72304 1.34993 11.523C-0.431602 13.7199 -0.451602 16.8399 1.3007 19.0599C0.856085 21.8522 2.39762 24.566 5.0253 25.6122C5.9176 27.9445 8.13913 29.4876 10.6637 29.4876C10.953 29.4876 11.2422 29.466 11.5299 29.4245C12.6037 30.2937 13.9391 30.7691 15.3299 30.7691C16.6914 30.7691 18.0037 30.3122 19.0668 29.4737C19.3791 29.5229 19.696 29.5476 20.0098 29.5476C22.4975 29.5476 24.7052 28.0353 25.6175 25.7491C28.2606 24.7383 29.839 22.0445 29.4313 19.2461C31.2129 17.0492 31.2329 13.9292 29.4806 11.7092C29.9252 8.91688 28.3837 6.20305 25.756 5.1569C24.8637 2.8246 22.6421 1.28153 20.1175 1.28153C19.8283 1.28153 19.5391 1.30307 19.2514 1.34461C18.1791 0.475383 16.8437 0 15.4529 0Z" fill="#FF7384"/>
            <path d="M15.6923 7.69336C13.6522 7.69336 11.6956 8.50379 10.253 9.94637C8.81043 11.389 8 13.3455 8 15.3856C8 17.4257 8.81043 19.3823 10.253 20.8249C11.6956 22.2675 13.6522 23.0779 15.6923 23.0779C17.7324 23.0779 19.6889 22.2675 21.1315 20.8249C22.5741 19.3823 23.3845 17.4257 23.3845 15.3856C23.3845 13.3455 22.5741 11.389 21.1315 9.94637C19.6889 8.50379 17.7324 7.69336 15.6923 7.69336Z" fill="#FF7384"/>
          </svg>
          <div class="t">

            <span> {{$ml.get('הומצאו משחקים ושאלות חדשות')}}</span> <br>
            <span>  {{$ml.get('על ידי תלמידי')}}</span><br>
            <span> {{school}}</span>
          </div>
        </div>
        <div class="invented-w">\
          <div v-if="invented.new_playlists.length" class="play-w">
            <PlaylistElement :key="i+'p'" :item="item" v-for="(item,i) in invented.new_playlists"  style="margin: 7px 0" />
          </div>
          <div v-if="invented.new_shootlists.length" class="shoot-w">
            <ShootlistElement :key="i+'s'" :item="item" v-for="(item,i) in invented.new_shootlists" style="margin: 7px 0" />
          </div>
        </div>
        <button class="rl" :style="inventedLen>4? '' : 'margin-top:20px;'" @click="goInventors" >
          {{$ml.get('לכל ממציאי המשחקים והשאלות')}}
        </button>
      </div>
    </modal>
  </transition>
</template>

<script>
import Modal from './Modal'
import ModalClose from './ModalClose'
import PlaylistElement from "./inventedGames/PlaylistElement";
import ShootlistElement from "./inventedGames/ShootlistElement";
export default {
  components: {
    Modal,
    ModalClose,
    PlaylistElement,
    ShootlistElement,
  },
  methods: {
    close() {
      this.$store.commit('modals/inventedGames/close');
    },
    goInventors(){
      this.close();
      this.$router.push({name: 'requests-playlist', params:{type: 'playlist'}});
    }
  },
  computed:{
    invented(){
      return this.$store.getters['modals/inventedGames/data']
    },
    school(){
      return this.$store.getters['user/school'].name
    },
    inventedLen(){
      return this.invented.new_playlists.length + this.invented.new_shootlists.length
    }
  }
}
</script>

<style lang="scss" scoped>

.modal {
  &.fade-anim {
    &-enter {
      .container {
        transform: translateY(-50px);
      }
    }
    &-enter-to {
      .container {
        transform: translateY(0);
      }
    }

    &-leave {
      .container {
        transform: translateY(0);
      }
    }
    &-leave-to {
      .container {
        transform: translateY(-50px);
      }
    }

    &-leave-active,
    &-enter-active {
      .container {
        transition: transform 0.3s ease;
      }
    }
  }
}

.container {
  width: 340px;

  position: relative;
  background: #F2F2F2;
  padding: 0 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  @media screen and (max-width: 350px){
    width: 97%;
  }

 .invented-title{
   padding: 23px 30px 28px 30px;
   font-style: normal;
   font-weight: normal;
   font-size: 14px;
   line-height: 19px;
   text-align: center;

   color: #00465B;
 }
  .rl{
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
    text-align: right;
    color: #149CC6;
  }
  .invented-w{
    max-height: 350px;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
  a{

    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-underline: none;
    text-align: center;

    color: #1A92B8;
  }
}

</style>
